<template>
  <el-row :gutter="isMobile ? 24 : 18">
    <el-col :xs="24" :sm="10">
      <p><b>Номер прицепа</b></p>
      <el-form-item
        prop="plateTrailer"
        :rules="{
          required: true,
          message: 'Введите номер прицепа',
          trigger: 'blur',
        }"
      >
        <el-input
          v-model="returnData.plateTrailer"
          placeholder="Введите номер прицепа"
          :disabled="readonly"
          @change="changed"
        />
      </el-form-item>
    </el-col>
    <el-col :xs="24" :sm="10">
      <p><b>Введите номер СТС</b></p>
      <el-form-item
        prop="stsTrailer"
        :rules="{
          required: true,
          message: 'Введите СТС прицепа',
          trigger: 'blur',
        }"
      >
        <el-input
          v-model="returnData.stsTrailer"
          placeholder="Введите номер СТС"
          :disabled="readonly"
          @change="changed"
        />
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
import mixinMain from '../Mixins/main'
export default {
  name: 'StsTrailer',
  mixins: [mixinMain],
  data() {
    return {
      returnData: {
        stsTrailer: '',
        plateTrailer: '',
      },
      source_model_id: 1,
    }
  },
}
</script>

<style lang="sass">
.sts-traler-valid
  .el-form-item__content
    line-height: inherit
    font-size: inherit
</style>
